import { lazy } from "react";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const MasterConfigSetting = ScreenLoader(
  lazy(() => import("../screens/MasterConfigSetting")),
);

// เฉพาะ maintainer (superadmin) — RoleGuard isSuperAdmin โดยไม่ใส่ requiredPermission
export const MasterConfigRoute = () => ({
  path: "master-config",
  element: (
    <AuthGuard>
      <RoleGuard isSuperAdmin={true}>
        <MasterConfigSetting />
      </RoleGuard>
    </AuthGuard>
  ),
});
